import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { IconProps } from 'shared/icons/iconProps';

export default function IconAdmin({
  extColor,
  isAutoscallable = true,
  sizeKey = '24x24',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.primary.main;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 24 24"
      fill={fill}
    >
      <path d="M12.1818 2L4 5.63636V11.0909C4 16.1364 7.49091 20.8545 12.1818 22C16.8727 20.8545 20.3636 16.1364 20.3636 11.0909V5.63636L12.1818 2ZM12.1818 5.63636C12.9051 5.63636 13.5988 5.9237 14.1103 6.43516C14.6218 6.94663 14.9091 7.64032 14.9091 8.36364C14.9091 9.08695 14.6218 9.78065 14.1103 10.2921C13.5988 10.8036 12.9051 11.0909 12.1818 11.0909C11.4585 11.0909 10.7648 10.8036 10.2533 10.2921C9.74188 9.78065 9.45455 9.08695 9.45455 8.36364C9.45455 7.64032 9.74188 6.94663 10.2533 6.43516C10.7648 5.9237 11.4585 5.63636 12.1818 5.63636ZM16.8455 16.5455C15.7455 18.2273 14.1 19.4909 12.1818 20.1091C10.2636 19.4909 8.61818 18.2273 7.51818 16.5455C7.20909 16.0909 6.94545 15.6364 6.72727 15.1545C6.72727 13.6545 9.19091 12.4273 12.1818 12.4273C15.1727 12.4273 17.6364 13.6273 17.6364 15.1545C17.4182 15.6364 17.1545 16.0909 16.8455 16.5455Z" />
    </svg>
  );
}
